module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_access-b5e441ac0876b44ee300158322e2f8bb.svg";